module.exports = function() {
  return new Worker("./" + "assets/js/dr.57a77b3c9424e00ba584.worker.js");
};